import { agentOrderHooks } from '@/manager'
import { DataOverview } from './data-overview'
import { OrderTableList } from './order-table-list'
import { SearchBar } from './search-bar'

/** 智能体订单管理 */
export const AgentDashboardOrderManagement = () => {
  const {
    orderUsers,
    loading,
    search,
    changePage,
    searchFormData,
    changeSearchForm,
    resetAndSearch
  } = agentOrderHooks.useOrderListData();
  const { orderSeatListForSearch, orderSeatListForCreate } = agentOrderHooks.useOrderSeatList();

  return (
    <div className='w-full h-full flex flex-col overflow-hidden gap-6'>
      <DataOverview />
      <SearchBar
        search={search}
        searchFormData={searchFormData}
        changeSearchForm={changeSearchForm}
        resetAndSearch={resetAndSearch}
        orderSeatListForSearch={orderSeatListForSearch}
        orderSeatListForCreate={orderSeatListForCreate}
      />
      <OrderTableList
        orderUsers={orderUsers}
        loading={loading}
        total={searchFormData.total}
        page={searchFormData.page}  
        pageSize={searchFormData.pageSize}
        changePage={changePage}
        search={search}
      />
    </div>
  )
}
